var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.734375,
    y: 0.412842,
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#636363"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6288 11.6975C24.0644 11.6975 27.66 15.2931 27.66 19.7287C27.66 24.1643 24.0644 27.7598 19.6288 27.7598C15.1932 27.7598 11.5977 24.1643 11.5977 19.7287C11.5977 15.2931 15.1932 11.6975 19.6288 11.6975ZM19.6288 13.3037C17.9248 13.3037 16.2906 13.9807 15.0857 15.1856C13.8808 16.3905 13.2039 18.0247 13.2039 19.7287C13.2039 21.4327 13.8808 23.0669 15.0857 24.2718C16.2906 25.4767 17.9248 26.1536 19.6288 26.1536C21.3328 26.1536 22.967 25.4767 24.1719 24.2718C25.3768 23.0669 26.0537 21.4327 26.0537 19.7287C26.0537 18.0247 25.3768 16.3905 24.1719 15.1856C22.967 13.9807 21.3328 13.3037 19.6288 13.3037ZM19.6288 14.91C19.8255 14.91 20.0154 14.9822 20.1624 15.1129C20.3094 15.2436 20.4033 15.4238 20.4263 15.6191L20.4319 15.7131V19.3962L22.606 21.5702C22.75 21.7147 22.8336 21.9087 22.8399 22.1126C22.8461 22.3166 22.7744 22.5153 22.6395 22.6683C22.5045 22.8213 22.3164 22.9173 22.1133 22.9366C21.9102 22.956 21.7073 22.8973 21.5459 22.7725L21.4704 22.7058L19.061 20.2965C18.9362 20.1715 18.856 20.009 18.8329 19.8339L18.8257 19.7287V15.7131C18.8257 15.5001 18.9103 15.2958 19.0609 15.1452C19.2115 14.9946 19.4158 14.91 19.6288 14.91Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLine);
export default __webpack_public_path__ + "static/media/timeLine.44937fe78e3dd2ab92d519c5bd018f01.svg";
export { ForwardRef as ReactComponent };